import React from "react";
import { Tag } from "antd";

// Tote statuses (open/closed/pickedup), job statuses once on a route, and
// route-plan statuses. Keep in sync with FilterScan2Pack STATUS_OPTIONS and
// the backend tote-status sync (see CLAUDE.md "Scan 2 Pack").
export const STATUS_CONFIG = {
  pending: { color: "blue", label: "Pending" },
  submitting: { color: "orange", label: "Processing" },
  submitted: { color: "cyan", label: "Submitted" },
  route_created: { color: "green", label: "Route Created" },
  open: { color: "blue", label: "Open" },
  closed: { color: "purple", label: "Closed" },
  pickedup: { color: "cyan", label: "Picked Up" },
  unassigned: { color: "default", label: "Unassigned" },
  assigned: { color: "green", label: "Assigned" },
  pickup_arrived: { color: "orange", label: "Pickup Arrived" },
  collected: { color: "geekblue", label: "Collected" },
  dropoff_arrived: { color: "orange", label: "Dropoff Arrived" },
  completed: { color: "green", label: "Completed" },
  failed: { color: "red", label: "Failed" }
};

const StatusTag = ({ status }) => {
  const config = STATUS_CONFIG[status] || {
    color: "default",
    label: status || "Pending"
  };
  return <Tag color={config.color}>{config.label}</Tag>;
};

export default StatusTag;
